export const env = {
  primaryMenuHoverDelayMS: 500,
};
